export const APP_STORE_URL = "https://apps.apple.com/us/app/solfej-ear-trainer-theory/id1487555711";
export const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.solfejio.solfej";